import type { DataTableColumn } from '@/components/custom/erp';
import type { PhuongThucThanhToan } from '@/types/schemas';

export const getDataTableColumns = (): DataTableColumn<PhuongThucThanhToan>[] => [
  {
    field: 'ma_pttt',
    headerName: 'Phương thức',
    width: 120
  },
  {
    field: 'ten_pttt',
    headerName: 'Diễn giải',
    width: 250
  },
  {
    field: 'ma_ph_thuc_hddt',
    headerName: 'Mã ph.thức HĐĐT',
    width: 150
  }
];
